// import React from 'react';
// import { useQuery } from '@apollo/client';
// import { defaultFiltersForDates } from 'pages/Dashboard/components/constant';
// import { ORDER_DATA } from 'pages/Dashboard/components/DashboardGraphQL';
// import Loader from 'components/common/Loader';
// import LineChart from '../../../LineChart';

// const OrderChart = ({ selectedOption }) => {
//   const { data, loading, error } = useQuery(ORDER_DATA, {
//     variables: defaultFiltersForDates(selectedOption),
//     fetchPolicy: 'network-only',
//   });
//   if (error) return `There is an error on this page : ${error.message} `;
//   if (loading)
//     return (
//       <div className="linechart-loader">
//         <Loader />
//       </div>
//     );

//   const combinedKeysSet = new Set();
//   let firstLineData = [];
//   let secondLineData = [];

//   if (data?.orderCountData?.PAID.length) {
//     firstLineData = data.orderCountData.PAID.map((val) => {
//       combinedKeysSet.add(val[defaultFiltersForDates(selectedOption).groupOn]);
//       return val.count;
//     });
//   }
//   if (data?.orderCountData?.PENDING.length) {
//     secondLineData = data.orderCountData.PENDING.map((val) => {
//       combinedKeysSet.add(val[defaultFiltersForDates(selectedOption).groupOn]);
//       return val.count;
//     });
//   }

//   const combinedKeys = Array.from(combinedKeysSet);

//   return (
//     <>
//       {' '}
//       <LineChart
//         combinedKeys={combinedKeys}
//         firstLineData={firstLineData}
//         secondLineData={secondLineData}
//         firstHeading="Paid Orders"
//         secondHeading="Pending Orders"
//       />
//     </>
//   );
// };

// export default OrderChart;

// import React from 'react';
// import { useQuery } from '@apollo/client';
// import { defaultFiltersForDates, formatXAxisLabels } from 'pages/Dashboard/components/constant';
// import { ORDER_DATA } from 'pages/Dashboard/components/DashboardGraphQL';
// import Loader from 'components/common/Loader';
// import LineChart from '../../../LineChart';

// const OrderChart = ({ selectedOption }) => {
//   const { data, loading, error } = useQuery(ORDER_DATA, {
//     variables: defaultFiltersForDates(selectedOption),
//     fetchPolicy: 'network-only',
//   });

//   if (error) return `There is an error on this page : ${error.message} `;
//   if (loading)
//     return (
//       <div className="linechart-loader">
//         <Loader />
//       </div>
//     );

//   let firstLineData = [];
//   let secondLineData = [];

//   // Get X-axis labels based on selected option
//   const xAxisLabels = formatXAxisLabels(selectedOption);

//   if (data?.orderCountData?.PAID?.length) {
//     firstLineData = data.orderCountData.PAID.map((val) => val.count);
//   }
//   if (data?.orderCountData?.PENDING?.length) {
//     secondLineData = data.orderCountData.PENDING.map((val) => val.count);
//   }

//   // Pad arrays to match X-axis labels length
//   while (firstLineData.length < xAxisLabels.length) {
//     firstLineData.push(0);
//   }
//   while (secondLineData.length < xAxisLabels.length) {
//     secondLineData.push(0);
//   }

//   return (
//     <LineChart
//       combinedKeys={xAxisLabels}
//       firstLineData={firstLineData}
//       secondLineData={secondLineData}
//       firstHeading="Paid Orders"
//       secondHeading="Pending Orders"
//     />
//   );
// };

// export default OrderChart;

import React from 'react';
import moment from 'moment';
import { useQuery } from '@apollo/client';
import {
  defaultFiltersForDates,
  formatXAxisLabels,
} from 'pages/Dashboard/components/constant';
import { ORDER_DATA } from 'pages/Dashboard/components/DashboardGraphQL';
import PermissionNotice from 'pages/Dashboard/components/PermissionNotice';
import Loader from 'components/common/Loader';
import LineChart from '../../../LineChart';

const OrderChart = ({ selectedOption, canView = true }) => {
  const { data, loading, error } = useQuery(ORDER_DATA, {
    variables: defaultFiltersForDates(selectedOption),
    fetchPolicy: 'network-only',
    skip: !canView,
  });

  if (!canView) {
    return (
      <PermissionNotice message="You do not have permission to view Orders chart." />
    );
  }

  if (error) return `There is an error on this page : ${error.message}`;
  if (loading)
    return (
      <div className="linechart-loader">
        <Loader />
      </div>
    );

  let firstLineData = [];
  let secondLineData = [];

  let xAxisLabels = formatXAxisLabels(selectedOption);

  if (data?.orderCountData) {
    const { PAID, PENDING } = data.orderCountData;

    if (selectedOption === 'this_year') {
      // Month-wise mapping
      const paidMap = {};
      const pendingMap = {};

      PAID?.forEach((item) => {
        const month = moment(item.day || item.month).format('MMM');
        paidMap[month] = (paidMap[month] || 0) + parseInt(item.count || 0, 10);
      });

      PENDING?.forEach((item) => {
        const month = moment(item.day || item.month).format('MMM');
        pendingMap[month] =
          (pendingMap[month] || 0) + parseInt(item.count || 0, 10);
      });

      firstLineData = xAxisLabels.map((label) => paidMap[label] || 0);
      secondLineData = xAxisLabels.map((label) => pendingMap[label] || 0);
    } else {
      // Day-wise mapping
      const paidMap = {};
      const pendingMap = {};

      PAID?.forEach((item) => {
        const date = moment(item.day).format('D MMM');
        paidMap[date] = parseInt(item.count, 10) || 0;
      });

      PENDING?.forEach((item) => {
        const date = moment(item.day).format('D MMM');
        pendingMap[date] = parseInt(item.count, 10) || 0;
      });

      xAxisLabels = xAxisLabels.filter((label) => {
        const date = moment(label, 'D MMM');
        return date.day() !== 0; // 0 = Sunday
      });

      firstLineData = xAxisLabels.map((label) => paidMap[label] || 0);
      secondLineData = xAxisLabels.map((label) => pendingMap[label] || 0);
    }
  }

  return (
    <LineChart
      combinedKeys={xAxisLabels}
      firstLineData={firstLineData}
      secondLineData={secondLineData}
      firstHeading="Paid Orders"
      secondHeading="Pending Orders"
    />
  );
};

export default OrderChart;
